module.exports = __webpack_public_path__ + "7bf0b53f575bb95a4fbf17cac8615b78.svg";